import type { ReviewGroupKey } from "./reviewRow.types";

export const GROUP_WORDS: Record<
  ReviewGroupKey,
  { title: string; hint: string; tag: string }
> = {
  ready: {
    title: "Ready to approve",
    hint: "Both models agree on a shared field, values clean.",
    tag: "Decision pending",
  },
  check: {
    title: "Check first",
    hint: "Has a pick. A value, a link, a copy or a second check needs a look.",
    tag: "Decision pending",
  },
  pick: {
    title: "Needs a pick",
    hint: "No field yet, a new field, or the two models gave different answers.",
    tag: "Decision pending",
  },
  hidden: {
    title: "Hidden by AI",
    hint: "The seller will not see these. Check each one.",
    tag: "FYI for ops",
  },
  approved: {
    title: "Approved",
    hint: "Saved. A field answered in an earlier session of this store lands here on its own.",
    tag: "Done",
  },
  ignored: {
    title: "Ignored",
    hint: "Left out of the published form.",
    tag: "Done",
  },
};

export const COLLAPSED_BY_DEFAULT: ReviewGroupKey[] = ["approved", "ignored"];

// Sections that read as done, where an unsaved row must say so.
export const DONE_LOOKING: ReviewGroupKey[] = ["hidden", "approved", "ignored"];
